exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hero[data-v-043ad97e]{margin-bottom:50px}.content[data-v-043ad97e]{margin-top:20px;justify-items:stretch}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-043ad97e","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/landing_Componentes/Seguridad.vue
// module id = 1583
// module chunks = 0